import type { DefaultMantineColor } from '@any-ui-react/core';
import { Badge, type BadgeProps } from '@mantine/core';

import { EmployeeStatus } from '@/common/graphql';
import { EmployeeStatusLabels } from '@/common/types';

const getStatusColor = (status: EmployeeStatus, overrides?: Partial<Record<EmployeeStatus, DefaultMantineColor>>) => {
  switch (status) {
    case EmployeeStatus.Active:
      return overrides?.ACTIVE ?? 'blue';
    case EmployeeStatus.Inactive:
      return overrides?.INACTIVE ?? 'gray';
    case EmployeeStatus.PreOnboarding:
      return overrides?.PRE_ONBOARDING ?? 'yellow';
    default:
      return 'gray';
  }
};

interface Props extends BadgeProps {
  status?: EmployeeStatus;
  statusColorOverrides?: Partial<Record<EmployeeStatus, DefaultMantineColor>>;
}

export const EmployeeStatusBadge = ({ status, statusColorOverrides, ...rest }: Props) => {
  if (!status) {
    return null;
  }

  return (
    <Badge {...rest} color={getStatusColor(status, statusColorOverrides)}>
      {EmployeeStatusLabels[status]}
    </Badge>
  );
};
